<!-- eslint-disable vue/no-undef-components -->
<template>
  <div
    class="farnam-contact-form-app"
    ref="getAQuoteFormAppWrap">
    <form
      action="https://crm.zoho.com/crm/WebToLeadForm"
      method="post"
      enctype="multipart/form-data"
      class="contact-form clearfix"
      id="contact_form"
      accept-charset="UTF-8"
      data-toggle="validator"
      name="WebToLeads5466000120703001">
      <input
        type="text"
        style="display: none"
        name="xnQsjsdp"
        value="7508c4bc4127c267599fef1770303cc75b54deafeea110d893ae2576e6e7d113" />
      <input
        type="hidden"
        name="zc_gad"
        id="zc_gad"
        value="" />
      <input
        type="text"
        style="display: none"
        name="xmIwtLD"
        value="07adc4b50b6a230e6e8ec6e5cc3d5b0a90b78a4b571a5d6f93fd902878dc5d3594392fd59b51e0dc1cf40d4d7ea710b5" />
      <input
        type="text"
        style="display: none"
        name="actionType"
        value="TGVhZHM=" />
      <div
        id="product_code_container"
        v-show="!state.isThankYouMessageVisible && state.formPlacing === FormPlacing.inBuildYourOwnModal"></div>
      <div
        id="form_error_container"
        v-show="!state.isThankYouMessageVisible"></div>

      <fieldset
        id="contact-form-reason"
        :class="{ hidden: state.formPlacing !== FormPlacing.onContactPage }"
        v-show="!state.isThankYouMessageVisible">
        <legend><h2>How can we direct your inquiry?</h2></legend>
        <div>
          <div class="row">
            <div class="col-xs-12 col-sm-4 text-center">
              <div
                id="heat-project-button"
                class="general-type-button heat-project"
                :class="{ selected: state.formPlacing !== FormPlacing.onContactPage }"
                @click="handleHeatingProjectButtonClick">
                <span class="link-button">
                  <span>Heating Project</span>
                </span>
              </div>
            </div>
            <div class="col-xs-12 col-sm-4 text-center">
              <div
                id="billing-button"
                class="general-type-button billing"
                @click="handleBillingButtonClick">
                <span class="link-button">
                  <span>Billing</span>
                </span>
              </div>
            </div>
            <div class="col-xs-12 col-sm-4 text-center">
              <div
                id="human-resources-button"
                class="general-type-button human-resources"
                @click="handleHumanResourcesButtonClick">
                <span class="link-button">
                  <span>Human Resources</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <div
        class="entire-contact-form"
        :class="{ hidden: state.formPlacing === FormPlacing.onContactPage }"
        v-show="!state.isThankYouMessageVisible">
        <fieldset id="contact-form-heating-needs">
          <div class="contact-form-heading-block what-are-you-heating">
            <div class="what-are-you-heating-content">
              <h2 class="contact-form-heading-title">Select a Heating Solution</h2>
              <div class="heating-types">
                <div
                  title="Forced Air Application"
                  class="heating-type-button forced-air"
                  data-type="forced-air">
                  <span>Forced Air</span>
                </div>
                <div
                  title="Still Air Application"
                  class="heating-type-button still-air"
                  data-type="still-air">
                  <span>Still Air</span>
                </div>
                <div
                  title="Surface Heating Application"
                  class="heating-type-button surface"
                  data-type="surface">
                  <span>Surface</span>
                </div>
                <div
                  title="Other"
                  class="heating-type-button other"
                  data-type="other">
                  <span>Other</span>
                </div>
              </div>
            </div>
          </div>

          <div
            class="hide-init"
            id="fieldset-contact-information">
            <h3 class="contact-form-title">Contact Information</h3>
            <p class="text-red">* Indicates Required Field</p>
            <div class="row">
              <div class="col-xs-12 col-sm-6">
                <div class="form-group flip-label required">
                  <input
                    title="First Name"
                    type="text"
                    class="form-control"
                    id="contact-first-name"
                    name="First Name"
                    required="true" />
                  <label for="contact-first-name">First Name</label>
                  <div class="help-block with-errors"></div>
                </div>
                <div class="form-group flip-label required">
                  <input
                    title="Last Name"
                    type="text"
                    class="form-control"
                    id="Last_Name"
                    name="Last Name"
                    required="true" />
                  <label for="Last_Name">Last Name</label>
                  <div class="help-block with-errors"></div>
                </div>
                <div class="form-group flip-label not-real full-form-only">
                  <input
                    title="Middle Name"
                    type="text"
                    class="form-control"
                    id="Middle_Name"
                    name="Middle Name"
                    tabindex="-1" />
                  <label for="Middle_Name">Middle Name</label>
                  <div class="help-block with-errors"></div>
                </div>
                <div class="form-group flip-label optional">
                  <input
                    title="Title"
                    type="text"
                    class="form-control"
                    id="contact-job-title"
                    name="LEADCF4" />
                  <label for="contact-job-title">Job Title</label>
                </div>
                <div class="form-group flip-label required">
                  <input
                    title="Email"
                    type="email"
                    class="form-control"
                    id="contact-email-address"
                    name="Email"
                    required="true"
                    autocomplete="on" />
                  <label for="contact-email-address">Email address</label>
                  <div class="help-block with-errors"></div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-6">
                <div class="form-group flip-label optional">
                  <input
                    title="Phone"
                    type="text"
                    class="form-control"
                    id="contact-phone"
                    name="Phone"
                    autocomplete="on" />
                  <label for="contact-phone">Phone #</label>
                  <div class="help-block with-errors"></div>
                </div>
                <div class="form-group flip-label required full-form-only">
                  <input
                    title="Business Name"
                    type="text"
                    class="form-control"
                    id="contact-business-name"
                    name="Company"
                    required="true"
                    autocomplete="on" />
                  <label for="contact-business-name">Business Name</label>
                  <div class="help-block with-errors"></div>
                </div>
                <div
                  class="form-group flip-label optional full-form-only"
                  style="display: none">
                  <input
                    title="Fax Number"
                    type="text"
                    class="form-control"
                    id="contact-fax"
                    name="Fax" />
                  <label for="contact-fax">Fax #</label>
                </div>
                <div class="form-group flip-label optional full-form-only">
                  <input
                    title="Mobile number"
                    type="text"
                    class="form-control"
                    id="contact-mobile"
                    name="Mobile" />
                  <label for="contact-mobile">Mobile #</label>
                </div>
                <div class="form-group flip-label optional">
                  <input
                    title="Industry"
                    type="text"
                    class="form-control"
                    id="contact-primary-industry"
                    name="LEADCF11" />
                  <label for="contact-primary-industry">Primary Industry</label>
                </div>
              </div>
              <div
                class="col-xs-12 col-sm-6"
                style="display: none">
                <div
                  class="form-group flip-label optional full-form-only"
                  style="visibility: hidden">
                  <input
                    title="Website"
                    type="text"
                    class="form-control"
                    id="contact-website"
                    name="Website" />
                  <label for="contact-website">Website</label>
                </div>
                <div
                  class="form-group flip-label optional full-form-only"
                  style="visibility: hidden">
                  <input
                    title="Heater Application"
                    type="text"
                    class="form-control"
                    id="contact-heater-application"
                    name="LEADCF19" />
                  <label for="contact-heater-application">Heater Application</label>
                </div>
                <div
                  class="form-group flip-label optional full-form-only"
                  style="visibility: hidden">
                  <input
                    title="Street Address 1"
                    type="text"
                    class="form-control"
                    id="contact-street-address-1"
                    name="Street" />
                  <label for="contact-street-address-1">Street Address</label>
                </div>
                <div
                  class="form-group flip-label optional full-form-only"
                  style="visibility: hidden">
                  <input
                    title="Street Address 2"
                    type="text"
                    class="form-control"
                    id="contact-street-address-2"
                    name="LEADCF3" />
                  <label for="contact-street-address-2">Street Address (continued)</label>
                </div>
                <div
                  class="form-group flip-label optional full-form-only"
                  style="visibility: hidden">
                  <input
                    title="City"
                    type="text"
                    class="form-control"
                    id="contact-city"
                    name="City" />
                  <label for="contact-city">City</label>
                </div>
                <div class="form-group flip-label required minimal-only">
                  <input
                    title="Phone"
                    type="text"
                    class="form-control"
                    id="contact-phone-2"
                    name="Phone2"
                    required="true" />
                  <label for="contact-phone-2">Phone #</label>
                  <div class="help-block with-errors"></div>
                </div>
                <div class="form-group flip-label required minimal-only">
                  <input
                    title="Business Name"
                    type="text"
                    class="form-control"
                    id="contact-business-name-2"
                    name="Company"
                    required="true"
                    autocomplete="on" />
                  <label for="contact-business-name-2">Business Name</label>
                  <div class="help-block with-errors"></div>
                </div>
              </div>

              <div class="col-xs-12 col-sm-12">
                <div
                  class="form-group hide-init form-group-checkboxes"
                  style="padding: 0">
                  <div
                    class="contact-form-bottom-checkboxes"
                    style="padding: 0">
                    <div
                      class="checkbox"
                      style="margin: 0; padding: 0">
                      <input
                        title="EDDU"
                        type="checkbox"
                        class="surface-shape-radio"
                        name="LEADCF104"
                        id="LEADCF104" />
                      <label for="LEADCF104"
                        >Check this box if you represent a university or educational institution to learn about potential incentives or credits for
                        linking to our website.</label
                      >
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xs-12 col-sm-6">
                <div class="form-group required">
                  <div class="help-block with-errors"></div>
                </div>
              </div>
            </div>
          </div>

          <div class="hide-init more-info-section">
            <div class="contact-form-accordion">
              <div class="contact-form-accordion-header">
                <h3>Describe your application and needs</h3>
                <div class="contact-form-accordion-header-button"></div>
              </div>
              <div class="contact-form-accordion-body">
                <div class="contact-form-accordion-body-content">
                  <h4>Please include</h4>
                  <ul>
                    <li>
                      <strong><em>A Description of Your Application</em></strong>
                    </li>
                    <li>Questions &amp; Comments</li>
                    <li>Specifications &amp; Limitations</li>
                    <li>Unique Conditions or Challenges</li>
                    <li>
                      <strong>Note:</strong> If you have a file to submit with your inquiry, please email it to
                      <a href="mailto:info@farnam-custom.com">info@farnam-custom.com</a>.
                    </li>
                  </ul>
                  <div class="form-group flip-label">
                    <textarea
                      id="other-heating-specs"
                      title="More info about application"
                      class="form-control"
                      name="LEADCF10"
                      rows="10"></textarea>
                    <label for="other-heating-specs"></label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="what-are-you-heating slide-content">
            <div class="heating-type-options heating-type-forced-air">
              <div class="contact-form-accordion">
                <div class="contact-form-accordion-header">
                  <div class="row">
                    <div class="col-xs-12">
                      <h3 id="forced-air-specs">Forced Air Specifications <span>(it's ok to skip this section)</span></h3>
                    </div>
                  </div>
                  <div class="contact-form-accordion-header-button"></div>
                </div>
                <div class="contact-form-accordion-body">
                  <div class="contact-form-accordion-body-content">
                    <div class="row">
                      <div class="col-md-6 heating-needs">
                        <div class="row">
                          <div class="col-xs-3 col-xl-4 radio">
                            <input
                              title="Type of gas being heated"
                              type="radio"
                              name="application_gas"
                              id="application_air"
                              value="Air" />
                            <label for="application_air">Air</label>
                          </div>
                          <div class="col-xs-4 col-xl-4 radio">
                            <input
                              title="Type of gas being heated"
                              type="radio"
                              name="application_gas"
                              id="application_nitrogen"
                              value="Nitrogen" />
                            <label for="application_nitrogen">Nitrogen</label>
                          </div>
                          <div class="col-xs-5 col-xl-4 radio">
                            <input
                              title="Type of gas being heated"
                              type="radio"
                              name="application_gas"
                              id="application_inert_gas"
                              value="Inert Gas" />
                            <label for="application_inert_gas">Inert Gas</label>
                          </div>
                          <div class="col-xs-12">
                            <div class="form-group flip-label">
                              <input
                                title="Flow Rate (SCFM)"
                                type="text"
                                class="form-control"
                                id="contact-application-flow-rate"
                                name="contact-application-flow-rate" />
                              <label for="contact-application-flow-rate">Flow Rate (SCFM)</label>
                            </div>
                          </div>
                          <div class="col-xs-12">
                            <div class="form-group flip-label">
                              <input
                                title="Pressure Available (PSI)"
                                type="text"
                                class="form-control"
                                id="contact-application-pressure"
                                name="contact-application-pressure" />
                              <label for="contact-application-pressure">Pressure Available at Inlet (PSI)</label>
                            </div>
                          </div>
                          <div class="col-xs-6">
                            <div class="checkbox">
                              <input
                                title="Has Thermocouple?"
                                type="checkbox"
                                name="contact-application-thermocouple"
                                value="Yes"
                                id="contact-application-thermocouple" />
                              <label for="contact-application-thermocouple">Thermocouple</label>
                            </div>
                          </div>
                          <div class="col-xs-6">
                            <div class="checkbox">
                              <input
                                title="Has controle panel?"
                                type="checkbox"
                                name="contact-application-cpanel"
                                value="Yes"
                                id="contact-application-cpanel" />
                              <label for="contact-application-cpanel">Control Panel</label><br />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 heating-needs">
                        <div class="form-group unit-field input-group">
                          <div class="flip-label">
                            <input
                              title="Inlet Temperature"
                              type="text"
                              class="form-control"
                              id="contact-application-inlet-temperature"
                              name="contact-application-inlet-temperature" />
                            <input
                              type="hidden"
                              name="contact-application-inlet-temperature_unit"
                              id="contact-application-inlet-temperature_unit"
                              value="F" />
                            <label for="contact-application-inlet-temperature">Inlet Temperature</label>
                          </div>
                          <div class="input-group-btn">
                            <button
                              title="Unit of Measure for Inlet Temperature"
                              type="button"
                              class="btn btn-default dropdown-toggle"
                              data-toggle="dropdown"
                              aria-expanded="false">
                              <span
                                class="btn-text"
                                id="inlet-scale"
                                >F &deg;</span
                              >
                              <span class="caret"></span>
                            </button>
                            <ul
                              class="dropdown-menu dropdown-menu-right"
                              role="menu">
                              <li role="menuitem">
                                <a
                                  href="#"
                                  data-value="F"
                                  >F &deg;</a
                                >
                              </li>
                              <li role="menuitem">
                                <a
                                  href="#"
                                  data-value="C"
                                  >C &deg;</a
                                >
                              </li>
                            </ul>
                          </div>
                          <!-- /btn-group -->
                        </div>
                        <!-- /input-group -->
                        <div class="form-group unit-field input-group">
                          <div class="flip-label">
                            <input
                              title="Exhaust Temperature"
                              type="text"
                              class="form-control"
                              id="contact-application-exhaust-temperature"
                              name="contact-application-exhaust-temperature" />
                            <input
                              type="hidden"
                              name="contact-application-exhaust-temperature_unit"
                              id="contact-application-exhaust-temperature_unit"
                              value="F" />
                            <label for="contact-application-exhaust-temperature">Exhaust Temperature</label>
                          </div>
                          <div class="input-group-btn">
                            <button
                              title="Unit of Measure for Inlet Temperature"
                              type="button"
                              class="btn btn-default dropdown-toggle"
                              data-toggle="dropdown"
                              aria-expanded="false">
                              <span
                                class="btn-text"
                                id="exhaust-scale"
                                >F &deg;</span
                              >
                              <span class="caret"></span>
                            </button>
                            <ul
                              class="dropdown-menu dropdown-menu-right"
                              role="menu">
                              <li role="menuitem">
                                <a
                                  href="#"
                                  data-value="F"
                                  >F &deg;</a
                                >
                              </li>
                              <li role="menuitem">
                                <a
                                  href="#"
                                  data-value="C"
                                  >C &deg;</a
                                >
                              </li>
                            </ul>
                          </div>
                          <!-- /btn-group -->
                        </div>
                        <!-- /input-group -->
                        <div class="form-group flip-label">
                          <input
                            title="Available Voltage"
                            type="text"
                            class="form-control"
                            id="contact-application-available-power"
                            name="contact-application-available-power" />
                          <label for="contact-application-available-power">Available Supply Voltage</label>
                        </div>
                        <div class="form-group flip-label">
                          <input
                            title="Quantity of Heaters"
                            type="number"
                            class="form-control"
                            id="cf-forced-heater-qty"
                            name="cf-forced-heater-qty" />
                          <label for="cf-forced-heater-qty">Quantity of Heaters</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /.row forced air -->

            <div class="heating-type-options heating-type-still-air">
              <div class="contact-form-accordion">
                <div class="contact-form-accordion-header">
                  <div class="row">
                    <div class="col-xs-12">
                      <h3 id="still-air-specs">Still Air Parameters (Enclosure Heaters) <span>(it's ok to skip this section)</span></h3>
                      <input
                        type="hidden"
                        name="cf-enclosure_calculated-heating-power"
                        id="cf-enclosure_calculated-heating-power"
                        value="" />
                      <input
                        type="hidden"
                        name="cf-enclosure_calculated-area"
                        id="cf-enclosure_calculated-area"
                        value="" />
                      <input
                        type="hidden"
                        name="cf-enclosure_calculated-k"
                        id="cf-enclosure_calculated-k"
                        value="" />
                    </div>
                  </div>
                  <div class="contact-form-accordion-header-button"></div>
                </div>
                <div class="contact-form-accordion-body">
                  <div class="contact-form-accordion-body-content">
                    <div class="row">
                      <div class="col-md-6 heating-needs">
                        <strong>Is your enclosure:</strong>
                        <div class="row radio">
                          <div class="col-md-6">
                            <input
                              title="Free Standing"
                              type="radio"
                              name="cf-enclosure_position"
                              id="cf-enclosure_position-free_standing"
                              value="Free-Standing" />
                            <label for="cf-enclosure_position-free_standing">Free-Standing</label>
                          </div>
                          <div class="col-md-6">
                            <input
                              title="Wall Mounted"
                              type="radio"
                              name="cf-enclosure_position"
                              id="cf-enclosure_position-wall_mounted"
                              value="Wall-Mounted" />
                            <label for="cf-enclosure_position-wall_mounted">Wall-Mounted</label>
                          </div>
                          <div class="col-md-6">
                            <input
                              title="On the ground"
                              type="radio"
                              name="cf-enclosure_position"
                              id="cf-enclosure_position-on_the_ground"
                              value="On the Ground" />
                            <label for="cf-enclosure_position-on_the_ground">On the Ground</label>
                          </div>
                          <div class="col-md-6">
                            <input
                              title="On ground against wall"
                              type="radio"
                              name="cf-enclosure_position"
                              id="cf-enclosure_position-on-ground-against-wall"
                              value="On Ground against a Wall" />
                            <label for="cf-enclosure_position-on-ground-against-wall">On Ground against a Wall</label>
                          </div>
                        </div>
                        <strong>Is another enclosure adjacent to this enclosure?</strong>
                        <div class="row radio">
                          <div class="col-md-6">
                            <input
                              title="No Adjacent Enclosure"
                              type="radio"
                              name="cf-enclosure_surrounded"
                              id="cf-enclosure_surrounded-no_sides"
                              value="No Sides" />
                            <label for="cf-enclosure_surrounded-no_sides">No enclosure on either side.</label>
                          </div>
                          <div class="col-md-6">
                            <input
                              title="Adjacent enclosure on one side"
                              type="radio"
                              name="cf-enclosure_surrounded"
                              id="cf-enclosure_surrounded-one_side"
                              value="One Side" />
                            <label for="cf-enclosure_surrounded-one_side">Yes, On One Side</label>
                          </div>
                          <div class="col-md-6">
                            <input
                              title="Adjacent enclosure on both sides"
                              type="radio"
                              name="cf-enclosure_surrounded"
                              id="cf-enclosure_surrounded-both_sides"
                              value="Both Sides" />
                            <label for="cf-enclosure_surrounded-both_sides">Yes, On Both Sides</label>
                          </div>
                        </div>
                        <strong>Enclosure Material:</strong>
                        <div class="row radio">
                          <div class="col-md-6">
                            <input
                              title="Painted Steel"
                              type="radio"
                              name="cf-enclosure_material"
                              id="cf-enclosure_material-painted_steel"
                              value="Painted Steel" />
                            <label for="cf-enclosure_material-painted_steel">Painted Steel</label>
                          </div>
                          <div class="col-md-6">
                            <input
                              title="Stainless Steel"
                              type="radio"
                              name="cf-enclosure_material"
                              id="cf-enclosure_material-stainless_steel"
                              value="Stainless Steel" />
                            <label for="cf-enclosure_material-stainless_steel">Stainless Steel</label>
                          </div>
                          <div class="col-md-6">
                            <input
                              title="Aluminum"
                              type="radio"
                              name="cf-enclosure_material"
                              id="cf-enclosure_material-aluminum"
                              value="Aluminum" />
                            <label for="cf-enclosure_material-aluminum">Aluminum</label>
                          </div>
                          <div class="col-md-6">
                            <input
                              title="Plastic or Insulated Stainless Steel"
                              type="radio"
                              name="cf-enclosure_material"
                              id="cf-enclosure_material-plastic_or_insulated_stainless"
                              value="Plastic or Insulated Stainless" />
                            <label for="cf-enclosure_material-plastic_or_insulated_stainless">Plastic or Insulated Stainless</label>
                          </div>
                        </div>
                        <!-- /.col -->
                        <strong>Enclosure Location:</strong>
                        <div class="row radio">
                          <div class="col-md-6">
                            <input
                              title="Inside Location"
                              type="radio"
                              name="cf-enclosure_location"
                              id="cf-enclosure_location-inside"
                              value="Inside" />
                            <label for="cf-enclosure_location-inside">Inside</label>
                          </div>
                          <div class="col-md-6">
                            <input
                              title="Outside Location"
                              type="radio"
                              name="cf-enclosure_location"
                              id="cf-enclosure_location-outside"
                              value="Outside" />
                            <label for="cf-enclosure_location-outside">Outside</label>
                          </div>
                        </div>
                        <!-- /.col -->
                      </div>
                      <div class="col-md-6">
                        <div class="group-header">Dimensions Location:</div>
                        <div class="form-group unit-field">
                          <div class="input-group flip-label">
                            <input
                              title="Enclosure Height"
                              type="number"
                              class="form-control"
                              name="cf-enclosure_dimensions_height"
                              id="cf-enclosure_dimensions_height"
                              aria-label="Height" />
                            <label
                              for="cf-enclosure_dimensions_height"
                              class="col-sm-4 control-label"
                              >Height</label
                            >
                            <input
                              type="hidden"
                              name="cf-enclosure_dimensions_height_unit"
                              id="cf-enclosure_dimensions_height_unit"
                              value="inches" />
                            <div class="input-group-btn">
                              <button
                                title="Unit of Measure for Height"
                                type="button"
                                class="btn btn-default dropdown-toggle"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false">
                                <span class="btn-text">Inches</span> <span class="caret"></span>
                              </button>
                              <ul class="dropdown-menu dropdown-menu-right">
                                <li>
                                  <a
                                    href="#"
                                    data-value="inches"
                                    >Inches</a
                                  >
                                </li>
                                <li>
                                  <a
                                    href="#"
                                    data-value="feet"
                                    >Feet</a
                                  >
                                </li>
                                <li>
                                  <a
                                    href="#"
                                    data-value="centimeters"
                                    >Centimeters</a
                                  >
                                </li>
                                <li>
                                  <a
                                    href="#"
                                    data-value="meters"
                                    >Meters</a
                                  >
                                </li>
                              </ul>
                            </div>
                            <!-- /btn-group -->
                          </div>
                          <!-- /input-group -->
                        </div>
                        <!-- /.form-group /.unit-field -->
                        <div class="form-group unit-field">
                          <div class="input-group flip-label">
                            <input
                              title="Enclosure Width"
                              type="number"
                              class="form-control"
                              name="cf-enclosure_dimensions_width"
                              id="cf-enclosure_dimensions_width"
                              aria-label="Width" />
                            <label
                              for="cf-enclosure_dimensions_width"
                              class="col-sm-4 control-label"
                              >Width</label
                            >
                            <input
                              type="hidden"
                              name="cf-enclosure_dimensions_width_unit"
                              id="cf-enclosure_dimensions_width_unit"
                              value="inches" />
                            <div class="input-group-btn">
                              <button
                                title="Unit of Measure for Width"
                                type="button"
                                class="btn btn-default dropdown-toggle"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false">
                                <span class="btn-text">Inches</span> <span class="caret"></span>
                              </button>
                              <ul class="dropdown-menu dropdown-menu-right">
                                <li>
                                  <a
                                    href="#"
                                    data-value="inches"
                                    >Inches</a
                                  >
                                </li>
                                <li>
                                  <a
                                    href="#"
                                    data-value="feet"
                                    >Feet</a
                                  >
                                </li>
                                <li>
                                  <a
                                    href="#"
                                    data-value="centimeters"
                                    >Centimeters</a
                                  >
                                </li>
                                <li>
                                  <a
                                    href="#"
                                    data-value="meters"
                                    >Meters</a
                                  >
                                </li>
                              </ul>
                            </div>
                            <!-- /btn-group -->
                          </div>
                          <!-- /input-group -->
                        </div>
                        <!-- /.form-group /.unit-field -->
                        <div class="form-group unit-field">
                          <div class="input-group flip-label">
                            <input
                              title="Enclosure Depth"
                              type="number"
                              class="form-control"
                              name="cf-enclosure_dimensions_depth"
                              id="cf-enclosure_dimensions_depth"
                              aria-label="Depth" />
                            <label
                              for="cf-enclosure_dimensions_depth"
                              class="col-sm-4 control-label"
                              >Depth</label
                            >
                            <input
                              type="hidden"
                              name="cf-enclosure_dimensions_depth_unit"
                              id="cf-enclosure_dimensions_depth_unit"
                              value="inches" />
                            <div class="input-group-btn">
                              <button
                                title="Unit of Measure for Depth"
                                type="button"
                                class="btn btn-default dropdown-toggle"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false">
                                <span class="btn-text">Inches</span> <span class="caret"></span>
                              </button>
                              <ul class="dropdown-menu dropdown-menu-right">
                                <li>
                                  <a
                                    href="#"
                                    data-value="inches"
                                    >Inches</a
                                  >
                                </li>
                                <li>
                                  <a
                                    href="#"
                                    data-value="feet"
                                    >Feet</a
                                  >
                                </li>
                                <li>
                                  <a
                                    href="#"
                                    data-value="centimeters"
                                    >Centimeters</a
                                  >
                                </li>
                                <li>
                                  <a
                                    href="#"
                                    data-value="meters"
                                    >Meters</a
                                  >
                                </li>
                              </ul>
                            </div>
                            <!-- /btn-group -->
                          </div>
                          <!-- /input-group -->
                        </div>
                        <!-- /.form-group /.unit-field -->
                        <div class="form-group flip-label">
                          <input
                            title="Quantity of Heaters"
                            type="number"
                            class="form-control"
                            id="cf-enclosure-heater-qty"
                            name="cf-enclosure-heater-qty" />
                          <label for="cf-enclosure-heater-qty">Quantity of Heaters</label>
                        </div>
                        <div class="group-header">Other Considerations:</div>
                        <div class="form-group unit-field">
                          <div class="input-group flip-label">
                            <input
                              title="Desired Enclosure Temp"
                              type="number"
                              class="form-control"
                              name="cf-enclosure_desired_interior_temp"
                              id="cf-enclosure_desired_interior_temp"
                              aria-label="Desired enclosure interior temp" />
                            <label
                              for="cf-enclosure_desired_interior_temp"
                              class="col-sm-8 control-label"
                              >Desired enclosure interior temp</label
                            >
                            <input
                              type="hidden"
                              name="cf-enclosure_desired_interior_temp_unit"
                              id="cf-enclosure_desired_interior_temp_unit"
                              value="F" />
                            <div class="input-group-btn">
                              <button
                                type="button"
                                class="btn btn-default dropdown-toggle"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false">
                                <span class="btn-text">&deg;F</span> <span class="caret"></span>
                              </button>
                              <ul class="dropdown-menu dropdown-menu-right">
                                <li>
                                  <a
                                    href="#"
                                    data-value="F"
                                    >&deg;F</a
                                  >
                                </li>
                                <li>
                                  <a
                                    href="#"
                                    data-value="C"
                                    >&deg;C</a
                                  >
                                </li>
                                <li>
                                  <a
                                    href="#"
                                    data-value="K"
                                    >&deg;K</a
                                  >
                                </li>
                              </ul>
                            </div>
                            <!-- /btn-group -->
                          </div>
                          <!-- /input-group -->
                        </div>
                        <div class="form-group unit-field">
                          <div class="input-group flip-label">
                            <input
                              title="Lowest Ambient Temp"
                              type="number"
                              class="form-control"
                              name="cf-enclosure_lowest_ambient_temp"
                              id="cf-enclosure_lowest_ambient_temp"
                              aria-label="Lowest ambient (outside) temp" />
                            <label
                              for="cf-enclosure_lowest_ambient_temp"
                              class="col-sm-8 control-label"
                              >Lowest ambient (outside) temp</label
                            >
                            <input
                              type="hidden"
                              name="cf-enclosure_lowest_ambient_temp_unit"
                              id="cf-enclosure_lowest_ambient_temp_unit"
                              value="F" />
                            <div class="input-group-btn">
                              <button
                                type="button"
                                class="btn btn-default dropdown-toggle"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false">
                                <span class="btn-text">&deg;F</span> <span class="caret"></span>
                              </button>
                              <ul class="dropdown-menu dropdown-menu-right">
                                <li>
                                  <a
                                    href="#"
                                    data-value="F"
                                    >&deg;F</a
                                  >
                                </li>
                                <li>
                                  <a
                                    href="#"
                                    data-value="C"
                                    >&deg;C</a
                                  >
                                </li>
                                <li>
                                  <a
                                    href="#"
                                    data-value="K"
                                    >&deg;K</a
                                  >
                                </li>
                              </ul>
                            </div>
                            <!-- /btn-group -->
                          </div>
                          <!-- /input-group -->
                        </div>
                        <div class="form-group unit-field">
                          <div class="input-group flip-label">
                            <input
                              title="Other heat sources"
                              type="number"
                              class="form-control"
                              name="cf-enclosure_other_heat"
                              id="cf-enclosure_other_heat"
                              aria-label="Heating Power (PV), from existing components, i.e. transformer)"
                              value="" />
                            <label
                              for="cf-enclosure_other_heat"
                              class="col-sm-8 control-label"
                              >Heating Power (PV)</label
                            >
                            <input
                              type="hidden"
                              name="cf-enclosure_other_heat_scale"
                              id="cf-enclosure_other_heat_unit"
                              value="watts" />
                            <div class="input-group-btn">
                              <button
                                type="button"
                                class="btn btn-default dropdown-toggle"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false">
                                <span class="btn-text">Watts</span> <span class="caret"></span>
                              </button>
                              <ul class="dropdown-menu dropdown-menu-right">
                                <li>
                                  <a
                                    href="#"
                                    data-value="watts"
                                    >Watts</a
                                  >
                                </li>
                              </ul>
                            </div>
                            <!-- /btn-group -->
                          </div>
                          <!-- /input-group -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /.row still air -->

            <div class="heating-type-options heating-type-surface">
              <div class="contact-form-accordion">
                <div class="contact-form-accordion-header">
                  <div class="row">
                    <div class="col-xs-12">
                      <h3 id="surface-heating-specs">Surface Parameters <span>(it's ok to skip this section)</span></h3>
                    </div>
                  </div>
                  <div class="contact-form-accordion-header-button"></div>
                </div>
                <div class="contact-form-accordion-body">
                  <div class="contact-form-accordion-body-content">
                    <div class="row">
                      <div class="col-md-6 heating-needs">
                        <div class="row">
                          <div class="col-xs-12">
                            <div class="form-group flip-label">
                              <input
                                title="Volts"
                                type="text"
                                class="form-control"
                                id="contact-application-surface-volts"
                                name="contact-application-surface-volts" />
                              <label for="contact-application-flow-rate">Volts</label>
                            </div>
                          </div>
                          <div class="col-xs-12">
                            <div class="form-group flip-label">
                              <input
                                title="Watts"
                                type="text"
                                class="form-control watt-density-rect-param watt-density-circ-param"
                                id="contact-application-surface-watts"
                                name="contact-application-surface-watts" />
                              <label for="contact-application-pressure">Watts</label>
                            </div>
                          </div>
                          <div class="col-xs-12">
                            <strong>Shape</strong>
                          </div>
                          <div class="col-xs12 col-sm-4 radio">
                            <input
                              title="Rectangle"
                              type="radio"
                              class="surface-shape-radio"
                              name="contact-application-surface-shape"
                              id="contact-application-surface-shape-rectangular"
                              value="Rectangular" />
                            <label for="contact-application-surface-shape-rectangular">Rectangular</label>
                          </div>
                          <div class="col-xs12 col-sm-4 radio">
                            <input
                              title="Circular"
                              type="radio"
                              class="surface-shape-radio"
                              name="contact-application-surface-shape"
                              id="contact-application-surface-shape-circular"
                              value="Circular" />
                            <label for="contact-application-surface-shape-circular">Circular</label>
                          </div>
                          <div class="col-xs12 col-sm-4 radio">
                            <input
                              title="Custom"
                              type="radio"
                              class="surface-shape-radio"
                              name="contact-application-surface-shape"
                              id="contact-application-surface-shape-custom"
                              value="Custom" />
                            <label for="contact-application-surface-shape-custom">Custom</label>
                          </div>
                          <div class="col-xs-12 surface-shape-options surface-shape-Rectangular">
                            <div class="group-header">Rectangular Surface</div>
                            <div class="row">
                              <div class="col-xs12 col-sm-6">
                                <div class="form-group unit-field">
                                  <div class="input-group flip-label">
                                    <input
                                      title="Length"
                                      type="number"
                                      class="form-control watt-density-rect-param"
                                      id="contact-application-surface-length"
                                      name="contact-application-surface-length" />
                                    <label for="contact-application-surface-length">Length</label>
                                    <input
                                      type="hidden"
                                      name="contact-application-surface-length_unit"
                                      class="watt-density-rect-param"
                                      id="contact-application-surface-length_unit"
                                      value="inches" />
                                    <div class="input-group-btn">
                                      <button
                                        title="Unit of Measure for Length"
                                        type="button"
                                        class="btn btn-default dropdown-toggle watt-density-rect-param"
                                        data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false">
                                        <span class="btn-text">Inches</span>
                                        <span class="caret"></span>
                                      </button>
                                      <ul class="dropdown-menu dropdown-menu-right">
                                        <li>
                                          <a
                                            href="#"
                                            data-value="inches"
                                            >Inches</a
                                          >
                                        </li>
                                        <li>
                                          <a
                                            href="#"
                                            data-value="feet"
                                            >Feet</a
                                          >
                                        </li>
                                        <li>
                                          <a
                                            href="#"
                                            data-value="centimeters"
                                            >Centimeters</a
                                          >
                                        </li>
                                        <li>
                                          <a
                                            href="#"
                                            data-value="meters"
                                            >Meters</a
                                          >
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="col-xs12 col-sm-6">
                                <div class="form-group unit-field">
                                  <div class="input-group flip-label">
                                    <input
                                      title="Width"
                                      type="number"
                                      class="form-control watt-density-rect-param"
                                      id="contact-application-surface-width"
                                      name="contact-application-surface-width" />
                                    <label for="contact-application-surface-width">Width</label>
                                    <input
                                      type="hidden"
                                      name="contact-application-surface-width_unit"
                                      class="watt-density-rect-param"
                                      id="contact-application-surface-width_unit"
                                      value="inches" />
                                    <div class="input-group-btn">
                                      <button
                                        title="Unit of Measure for Width"
                                        type="button"
                                        class="btn btn-default dropdown-toggle watt-density-rect-param"
                                        data-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false">
                                        <span class="btn-text">Inches</span>
                                        <span class="caret"></span>
                                      </button>
                                      <ul class="dropdown-menu dropdown-menu-right">
                                        <li>
                                          <a
                                            href="#"
                                            data-value="inches"
                                            >Inches</a
                                          >
                                        </li>
                                        <li>
                                          <a
                                            href="#"
                                            data-value="feet"
                                            >Feet</a
                                          >
                                        </li>
                                        <li>
                                          <a
                                            href="#"
                                            data-value="centimeters"
                                            >Centimeters</a
                                          >
                                        </li>
                                        <li>
                                          <a
                                            href="#"
                                            data-value="meters"
                                            >Meters</a
                                          >
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="col-xs12">
                                <div class="calc-watt-density rectangle"></div>
                              </div>
                            </div>
                          </div>
                          <div class="col-xs-12 surface-shape-options surface-shape-Circular">
                            <div class="group-header">Circular Surface</div>
                            <div class="form-group unit-field">
                              <div class="input-group flip-label">
                                <input
                                  title="Diameter"
                                  type="number"
                                  class="form-control watt-density-circ-param"
                                  id="contact-application-surface-diameter"
                                  name="contact-application-surface-diameter" />
                                <label for="contact-application-surface-diameter">Diameter</label>
                                <input
                                  type="hidden"
                                  name="contact-application-surface-diameter_unit"
                                  class="watt-density-circ-param"
                                  id="contact-application-surface-diameter_unit"
                                  value="inches" />
                                <div class="input-group-btn">
                                  <button
                                    title="Unit of Measure for Diameter"
                                    type="button"
                                    class="btn btn-default dropdown-toggle watt-density-circ-param"
                                    data-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false">
                                    <span class="btn-text">Inches</span> <span class="caret"></span>
                                  </button>
                                  <ul class="dropdown-menu dropdown-menu-right">
                                    <li>
                                      <a
                                        href="#"
                                        data-value="inches"
                                        >Inches</a
                                      >
                                    </li>
                                    <li>
                                      <a
                                        href="#"
                                        data-value="feet"
                                        >Feet</a
                                      >
                                    </li>
                                    <li>
                                      <a
                                        href="#"
                                        data-value="centimeters"
                                        >Centimeters</a
                                      >
                                    </li>
                                    <li>
                                      <a
                                        href="#"
                                        data-value="meters"
                                        >Meters</a
                                      >
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                            <div class="col-xs12">
                              <div class="calc-watt-density circle"></div>
                            </div>
                          </div>
                          <div class="col-xs-12 surface-shape-options surface-shape-Custom">
                            <div class="group-header">Custom Surface</div>
                            <strong>Upload a Drawing (20 MB Max) :</strong>
                            <div class="form-group file-upload">
                              <input
                                title="Upload custom file"
                                type="file"
                                name="theFile"
                                id="theFile"
                                multiple />
                            </div>
                            <div class="form-group flip-label">
                              <textarea
                                class="form-control"
                                rows="5"
                                id="contact-application-surface-description"
                                name="contact-application-surface-description"></textarea>
                              <label for="contact-application-surface-description">Custom Shape Description</label>
                            </div>
                          </div>
                        </div>
                        <div class="form-group flip-label">
                          <input
                            title="Listing requirements"
                            type="text"
                            class="form-control"
                            id="contact-application-listing-requirements"
                            name="contact-application-listing-requirements" />
                          <label for="contact-application-listing-requirements">Please Provide Any Listing Requirements</label>
                        </div>
                        <div class="form-group flip-label">
                          <input
                            title="Lead Time"
                            type="text"
                            class="form-control"
                            id="contact-application-lead-time"
                            name="contact-application-lead-time" />
                          <label for="contact-application-lead-time">Lead Time Requirements:</label>
                        </div>
                        <div class="form-group flip-label">
                          <input
                            title="Quantity of Heaters"
                            type="number"
                            class="form-control"
                            id="cf-surface-heater-qty"
                            name="cf-surface-heater-qty" />
                          <label for="cf-surface-heater-qty">Quantity of Heaters</label>
                        </div>
                      </div>
                      <div class="col-md-6 heating-needs">
                        <div class="form-group input-group select-group select">
                          <div class="flip-label">
                            <select
                              title="Annual Usage"
                              class="form-control"
                              id="contact-application-surface-annual-usage"
                              name="contact-application-surface-annual-usage">
                              <option></option>
                              <option>10+</option>
                              <option>50+</option>
                              <option>250+</option>
                              <option>500+</option>
                              <option>1,000+</option>
                              <option>5,000+</option>
                            </select>
                            <label
                              for="contact-application-surface-annual-usage"
                              class="focused"
                              >Estimated Annual Usage</label
                            >
                          </div>
                        </div>
                        <!-- /input-group -->
                        <div class="row">
                          <div class="col-xs-12">
                            <strong>Attachment Method:</strong>
                          </div>
                          <div class="col-xs-12 col-sm-6 radio">
                            <input
                              title="No Attachment Needed"
                              type="radio"
                              class="surface-attachment-radio"
                              name="contact-application-attachment"
                              id="contact-application-attachment-none"
                              value="none" />
                            <label for="contact-application-attachment-none">No attachment method.</label>
                          </div>
                          <div class="col-xs-12 col-sm-6 radio">
                            <input
                              title="Vulcanized to Metal"
                              type="radio"
                              class="surface-attachment-radio"
                              name="contact-application-attachment"
                              id="contact-application-attachment-vulcanized"
                              value="vulcanized" />
                            <label for="contact-application-attachment-vulcanized">Vulcanized to metal</label>
                          </div>
                          <div class="col-xs-12 col-sm-6 radio">
                            <input
                              title="Straps"
                              type="radio"
                              class="surface-attachment-radio"
                              name="contact-application-attachment"
                              id="contact-application-attachment-straps"
                              value="straps" />
                            <label for="contact-application-attachment-straps">Straps</label>
                          </div>
                          <div class="col-xs-12 col-sm-6 radio">
                            <input
                              title="Pressure Sensitive Adhesive"
                              type="radio"
                              class="surface-attachment-radio"
                              name="contact-application-attachment"
                              id="contact-application-attachment-psa"
                              value="psa" />
                            <label for="contact-application-attachment-psa">Pressure Sensitive Adhesive</label>
                          </div>
                        </div>
                        <div class="form-group flip-label select">
                          <select
                            title="Temperature Sensor"
                            class="form-control"
                            id="contact-application-surface-temp-sensor"
                            name="contact-application-surface-temp-sensor">
                            <option>No Temperature Sensor Needed</option>
                            <option>Thermistor</option>
                            <option>RTD</option>
                            <option>Thermocouple (Type K standard. Others available)</option>
                          </select>
                          <label
                            for="contact-application-surface-temp-sensor"
                            class="focused"
                            >Temperature Sensor</label
                          >
                        </div>
                        <div class="form-group flip-label select">
                          <select
                            title="Thermostat"
                            class="form-control"
                            id="contact-application-surface-thermostat"
                            name="contact-application-surface-thermostat">
                            <option>No Thermostat is Needed</option>
                            <option>Regulation Thermostat</option>
                            <option>High Limit Thermostat</option>
                            <option>Opening temperature, standard tolerance</option>
                          </select>
                          <label
                            for="contact-application-surface-temp-sensor"
                            class="focused"
                            >Thermostat</label
                          >
                        </div>
                        <div
                          class="row"
                          id="cf-surface-thermostat-location">
                          <div class="col-xs-12">
                            <strong>Thermostat Location:</strong>
                          </div>
                          <div
                            class="col-xs-12 col-sm-6 radio"
                            style="margin-bottom: 25px">
                            <input
                              title="Thermostat in circuit"
                              type="radio"
                              class="surface-attachment-radio"
                              name="contact-application-surface-thermostat-location"
                              id="contact-application-surface-thermostat-location-internal"
                              value="In Circuit / Internal" />
                            <label for="contact-application-surface-thermostat-location-internal">In Circuit / Internal</label>
                          </div>
                          <div class="col-xs-12 col-sm-6 radio">
                            <input
                              title="Thermostat External"
                              type="radio"
                              class="surface-attachment-radio"
                              name="contact-application-surface-thermostat-location"
                              id="contact-application-surface-thermostat-location-external"
                              value="External" />
                            <label for="contact-application-surface-thermostat-location-external">External</label>
                          </div>
                        </div>
                        <div class="form-group flip-label select">
                          <select
                            title="Lead Length"
                            class="form-control"
                            id="contact-application-lead-length"
                            name="contact-application-lead-length">
                            <option>6"</option>
                            <option>8"</option>
                            <option>10"</option>
                            <option selected>12"</option>
                            <option>14"</option>
                            <option>16"</option>
                            <option>18"</option>
                            <option>Other</option>
                          </select>
                          <label
                            for="contact-application-lead-length"
                            class="focused"
                            >Lead Wire Length?</label
                          >
                        </div>
                        <div class="form-group flip-label lead-length-custom accordion-body collapse">
                          <input
                            title="Specify Lead Length"
                            type="text"
                            class="form-control"
                            id="contact-application-lead-length-other"
                            name="contact-application-lead-length-other" />
                          <label for="contact-application-lead-length-other">Specify Lead Length</label>
                        </div>
                        <div class="form-group flip-label select">
                          <select
                            class="form-control"
                            id="contact-application-surface-lead-type"
                            name="contact-application-surface-lead-type">
                            <option>No Preference</option>
                            <option>Extruded silicone rubber/Sil-A-Blend</option>
                            <option>PTFE/Teflon</option>
                            <option>MG</option>
                          </select>
                          <label
                            for="contact-application-surface-lead-type"
                            class="focused"
                            >Lead Type</label
                          >
                        </div>
                        <div class="form-group flip-label">
                          <input
                            title="Connectors needed"
                            type="text"
                            class="form-control"
                            id="contact-application-connectors"
                            name="contact-application-connectors" />
                          <label for="contact-application-connectors">Connector(s) Needed?</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /.row still air -->
          </div>

          <!-- Products of interest -->
          <div class="hide-init products-of-interest">
            <div class="contact-form-accordion">
              <div class="contact-form-accordion-header">
                <h3>Additional Products and Services <span>(include any additional products or services of interest)</span></h3>
                <div class="contact-form-accordion-header-button"></div>
              </div>
              <div class="contact-form-accordion-body">
                <div class="contact-form-accordion-body-content">
                  <p>Include any additional products of interest.</p>
                  <div class="row products">
                    <!-- Enclosure Heaters //-->

                    <!-- Axial and Cross Flow Heaters -->

                    <!-- Temperature Controllers //-->
                    <div
                      class="panel-group col-xs-12"
                      id="accordion-tempcontrollers"
                      role="tablist"
                      aria-multiselectable="true">
                      <div class="panel panel-default">
                        <div
                          class="panel-heading"
                          role="tab"
                          id="heading-temperature-controllers">
                          <h4 class="panel-title">
                            <a
                              role="button"
                              data-toggle="collapse"
                              data-target="#collapse-temperature-controllers"
                              data-parent="#accordion"
                              href="#0"
                              aria-expanded="false"
                              aria-controls="collapse-temperature-controllers">
                              Temperature Controllers
                            </a>
                          </h4>
                        </div>
                        <div
                          id="collapse-temperature-controllers"
                          class="panel-collapse collapse"
                          role="tabpanel"
                          aria-labelledby="heading-temperature-controllers">
                          <div class="panel-body">
                            <div class="row">
                              <div class="col-xs-6 col-sm-4">
                                <div class="checkbox">
                                  <input
                                    title="Interested in Temperature Controllers"
                                    type="checkbox"
                                    name="LEADCF1"
                                    value="Temperature Controllers"
                                    id="contact-poi-temperature-controllers" />
                                  <label for="contact-poi-temperature-controllers">Temperature Controllers</label>
                                </div>
                              </div>
                              <div class="col-xs-6 col-sm-4">
                                <div class="checkbox">
                                  <input
                                    title="Interested in Stand Alone Controllers"
                                    type="checkbox"
                                    name="LEADCF1"
                                    value="Stand-alone Controllers"
                                    id="contact-poi-stand-alone-controllers" />
                                  <label for="contact-poi-stand-alone-controllers">Stand-alone Controllers</label>
                                </div>
                              </div>
                              <div class="col-xs-6 col-sm-4">
                                <div class="checkbox">
                                  <input
                                    title="Interested in Heater Control Units"
                                    type="checkbox"
                                    name="LEADCF1"
                                    value="Heater Control Units"
                                    id="contact-poi-heater-control-units" />
                                  <label for="contact-poi-heater-control-units">Heater Control Units</label>
                                </div>

                                <div class="checkbox contact-option">
                                  <input
                                    title="Interested in Axial Fan Heaters"
                                    type="checkbox"
                                    name="LEADCF1"
                                    value="Axial Fan Heaters"
                                    id="contact-poi-axial-fan-heaters" />
                                  <label for="contact-poi-axial-fan-heaters">Axial Fan Heaters</label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Replacement Heater //-->
                    <div
                      class="panel-group col-xs-12"
                      id="accordion-replacement"
                      role="tablist"
                      aria-multiselectable="true">
                      <div class="panel panel-default">
                        <div
                          class="panel-heading"
                          role="tab"
                          id="heading-replacement">
                          <h4 class="panel-title">
                            <a
                              role="button"
                              data-toggle="collapse"
                              data-target="#collapse-replacement"
                              data-parent="#accordion"
                              href="#0"
                              aria-expanded="false"
                              aria-controls="collapse-replacement">
                              Replacement Heater
                            </a>
                          </h4>
                        </div>
                        <div
                          id="collapse-replacement"
                          class="panel-collapse collapse"
                          role="tabpanel"
                          aria-labelledby="heading-replacement">
                          <div class="panel-body">
                            <div class="row">
                              <div class="col-xs-12 col-sm-4">
                                <div class="form-group flip-label">
                                  <input
                                    title="Part # Description"
                                    type="text"
                                    class="form-control"
                                    id="contact-replacement-heater"
                                    name="contact-replacement-heater" />
                                  <label for="contact-replacement-heater">Part # or Description</label>
                                  <input
                                    type="hidden"
                                    name="LEADCF1"
                                    value=""
                                    id="contact-replacement-heater-part" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- /Custom //-->
                    </div>

                    <!-- Custom //-->
                    <div
                      class="panel-group col-xs-12"
                      id="accordion-custom"
                      role="tablist"
                      aria-multiselectable="true">
                      <div class="panel panel-default">
                        <div
                          class="panel-heading"
                          role="tab"
                          id="heading-custom">
                          <h4 class="panel-title">
                            <a
                              role="button"
                              data-toggle="collapse"
                              data-target="#collapse-custom"
                              data-parent="#accordion"
                              href="#0"
                              aria-expanded="false"
                              aria-controls="collapse-custom">
                              Custom Solution
                            </a>
                          </h4>
                        </div>
                        <div
                          id="collapse-custom"
                          class="panel-collapse collapse"
                          role="tabpanel"
                          aria-labelledby="heading-custom">
                          <div class="panel-body">
                            <div class="row">
                              <div class="col-xs-6 col-sm-4">
                                <div class="checkbox">
                                  <input
                                    title="Drying"
                                    type="checkbox"
                                    name="LEADCF1"
                                    value="Drying"
                                    id="contact-poi-drying" />
                                  <label for="contact-poi-drying">Drying</label>
                                </div>
                              </div>
                              <div class="col-xs-6 col-sm-4">
                                <div class="checkbox">
                                  <input
                                    title="Curing"
                                    type="checkbox"
                                    name="LEADCF1"
                                    value="Curing"
                                    id="contact-poi-curing" />
                                  <label for="contact-poi-curing">Curing</label>
                                </div>
                              </div>
                              <div class="col-xs-6 col-sm-4">
                                <div class="checkbox">
                                  <input
                                    title="Enclosure Heating"
                                    type="checkbox"
                                    name="LEADCF1"
                                    value="Enclosure Heating"
                                    id="contact-poi-customenclosure" />
                                  <label for="contact-poi-customenclosure">Enclosure Heating</label>
                                </div>
                              </div>
                              <div class="col-xs-6 col-sm-4">
                                <div class="checkbox">
                                  <input
                                    title="Heating a Room"
                                    type="checkbox"
                                    name="LEADCF1"
                                    value="Heating a Room"
                                    id="contact-poi-room" />
                                  <label for="contact-poi-room">Heating a Room</label>
                                </div>
                              </div>
                              <div class="col-xs-6 col-sm-4">
                                <div class="checkbox">
                                  <input
                                    title="Heating a stream of air"
                                    type="checkbox"
                                    name="LEADCF1"
                                    value="Heating a stream of air."
                                    id="contact-poi-airstream" />
                                  <label for="contact-poi-airstream">Heating a Stream of Air</label>
                                </div>
                                <div class="checkbox contact-option">
                                  <input
                                    title="High Flow"
                                    type="checkbox"
                                    name="LEADCF1"
                                    value="High Flow"
                                    id="contact-poi-air-high-flow" />
                                  <label for="contact-poi-air-high-flow">High Flow</label>
                                </div>
                                <div class="checkbox contact-option">
                                  <input
                                    title="Low Flow"
                                    type="checkbox"
                                    name="LEADCF1"
                                    value="Low Flow"
                                    id="contact-poi-air-low-flow" />
                                  <label for="contact-poi-air-low-flow">Low Flow</label>
                                </div>
                              </div>
                              <div class="col-xs-6 col-sm-4">
                                <div class="checkbox">
                                  <input
                                    title="Heating a solid"
                                    type="checkbox"
                                    name="LEADCF1"
                                    value="Heating a solid."
                                    id="contact-poi-heatsolid" />
                                  <label for="contact-poi-heatsolid">Heating a Solid</label>
                                </div>
                                <div class="checkbox contact-option">
                                  <input
                                    title="Forced Convection"
                                    type="checkbox"
                                    name="LEADCF1"
                                    value="Forced Convection"
                                    id="contact-poi-solid-forced-convection" />
                                  <label for="contact-poi-solid-forced-convection">Forced Convection</label>
                                </div>
                                <div class="checkbox contact-option">
                                  <input
                                    title="Conduction"
                                    type="checkbox"
                                    name="LEADCF1"
                                    value="Conduction"
                                    id="contact-poi-solid-conduction" />
                                  <label for="contact-poi-solid-conduction">Conduction</label>
                                </div>
                              </div>
                              <div class="col-xs-6 col-sm-4">
                                <div class="checkbox">
                                  <input
                                    title="Heating a liquid"
                                    type="checkbox"
                                    name="LEADCF1"
                                    value="Heating a liquid."
                                    id="contact-poi-heatliquid" />
                                  <label for="contact-poi-heatliquid">Heating a Liquid</label>
                                </div>
                              </div>
                              <div class="col-xs-6 col-sm-4">
                                <div class="checkbox">
                                  <input
                                    title="Absorbing a load"
                                    type="checkbox"
                                    name="LEADCF1"
                                    value="Absorbing a load."
                                    id="contact-poi-absorbing" />
                                  <label for="contact-poi-absorbing">Absorbing a Load</label>
                                </div>
                              </div>
                              <div class="col-xs-6 col-sm-4">
                                <div class="checkbox">
                                  <input
                                    title="Retrofit"
                                    type="checkbox"
                                    name="LEADCF1"
                                    value="Retrofit"
                                    id="contact-poi-retrofit" />
                                  <label for="contact-poi-retrofit">Retrofit</label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- /Custom //-->
                    </div>
                    <!-- Engineering //-->
                    <div
                      class="panel-group col-xs-12"
                      id="accordion-engineering"
                      role="tablist"
                      aria-multiselectable="true">
                      <div class="panel panel-default">
                        <div
                          class="panel-heading"
                          role="tab"
                          id="heading-engineering">
                          <h4 class="panel-title">
                            <a
                              role="button"
                              data-toggle="collapse"
                              data-target="#collapse-engineering"
                              data-parent="#accordion"
                              href="#0"
                              aria-expanded="false"
                              aria-controls="collapse-engineering">
                              Engineering Help
                            </a>
                          </h4>
                        </div>
                        <div
                          id="collapse-engineering"
                          class="panel-collapse collapse"
                          role="tabpanel"
                          aria-labelledby="heading-engineering">
                          <div class="panel-body">
                            <div class="row">
                              <div class="col-xs-6 col-sm-4">
                                <div class="checkbox">
                                  <input
                                    title="Consultation"
                                    type="checkbox"
                                    name="LEADCF1"
                                    value="Engineering Consultation"
                                    id="contact-poi-consultation" />
                                  <label for="contact-poi-consultation">Consultation</label>
                                </div>
                              </div>
                              <div class="col-xs-6 col-sm-4">
                                <div class="checkbox">
                                  <input
                                    title="Troubleshooting"
                                    type="checkbox"
                                    name="LEADCF1"
                                    value="Engineering Troubleshooting"
                                    id="contact-poi-troubleshooting" />
                                  <label for="contact-poi-troubleshooting">Troubleshooting</label>
                                </div>
                              </div>
                              <div class="col-xs-6 col-sm-4">
                                <div class="checkbox">
                                  <input
                                    title="Heater Hook Up"
                                    type="checkbox"
                                    name="LEADCF1"
                                    value="Heater Hook-up Help"
                                    id="contact-poi-help" />
                                  <label for="contact-poi-help">Heater Hook-up Help</label>
                                </div>
                              </div>
                              <div class="col-xs-6 col-sm-4">
                                <div class="checkbox">
                                  <input
                                    title="Auto Tuning"
                                    type="checkbox"
                                    name="LEADCF1"
                                    value="Auto Tuning"
                                    id="contact-poi-autotuning" />
                                  <label for="contact-poi-autotuning">Auto Tuning</label>
                                </div>
                              </div>
                              <div class="col-xs-12 col-sm-4">
                                <div class="checkbox">
                                  <input
                                    title="Other"
                                    type="checkbox"
                                    name="LEADCF1"
                                    value="Other Engineering Help"
                                    id="contact-poi-engineering-other" />
                                  <label for="contact-poi-engineering-other">Other</label>
                                </div>
                                <div class="form-group flip-label contact-option">
                                  <input
                                    title="Describe"
                                    type="text"
                                    class="form-control"
                                    id="other-engineering-help"
                                    name="other-engineering-help" />
                                  <label for="other-engineering-help">Please Describe</label>
                                  <input
                                    type="hidden"
                                    name="LEADCF1"
                                    value=""
                                    id="other-engineering-help-description" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- /engineering //-->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="hide-init full-form-only"
            id="how-did-you-find-us">
            <div class="contact-form-accordion">
              <div class="contact-form-accordion-header">
                <h3>How did you find us? <span>(it's ok to skip this section)</span></h3>
                <div class="contact-form-accordion-header-button"></div>
              </div>
              <div class="contact-form-accordion-body">
                <div class="contact-form-accordion-body-content">
                  <div class="form-group flip-label">
                    <input
                      title="How did you hear about us"
                      type="text"
                      class="form-control"
                      id="contact-how-did-you-find-us"
                      name="LEADCF12" />
                    <label for="contact-how-did-you-find-us">Google, referral, etc.</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </fieldset>

        <div class="form-group required hide-init form-group-checkboxes">
          <div class="contact-form-bottom-checkboxes">
            <div class="checkbox required">
              <input
                title="GDPR Acknowledgment"
                type="checkbox"
                class="surface-shape-radio"
                name="LEADCF106"
                id="LEADCF106"
                checked />
              <label
                for="LEADCF106"
                style="font-weight: bold; color: #eb2e2e !important"
                >General Data Privacy Authorization</label
              >
            </div>
            <div class="checkbox">
              <input
                title="Email Opt Out"
                type="checkbox"
                class="surface-shape-radio"
                name="Email Opt Out"
                id="Email_Opt_Out" />
              <label for="Email_Opt_Out">Opt-out</label>
            </div>
            <div class="hide-init checkbox">
              <input
                title="Receive occasional product updates"
                type="checkbox"
                name="LEADCF102"
                id="receive-product-updates"
                checked />
              <label for="receive-product-updates">Check here to receive occasional product updates</label>
            </div>
          </div>
        </div>

        <div class="hide-init form-group-capcha">
          <input
            type="hidden"
            id="lead-source"
            name="Lead Source"
            value="Website" />
          <br />
          <div style="text-align: center">
            <div
              style="display: inline-block"
              class="g-recaptcha text-center"
              data-sitekey="6LfwZX4qAAAAAHAEpn2XPF-cLeHtWZuhPuDr9gdL"
              data-callback="EnableHuman"
              data-expired-callback="DisableHuman"
              captcha-verified="false"></div>
          </div>
          <br />
          <div class="w-full flex items-center justify-center gap-2">
            <input
              title="Submit contact form."
              type="submit"
              name="save"
              class="btn btn-calculate col-xs-4 col-xs-offset-4 col-sm-2 col-sm-offset-5"
              id="contact-form-submit"
              style="display: none"
              value="Submit" />
            <input
              title="Submit Contact Form."
              type="submit"
              name="save"
              class="btn col-xs-4 col-xs-offset-4 col-sm-2 col-sm-offset-5"
              id="contact-form-submit-antispam"
              value="Submit"
              disabled />
          </div>
          <p class="col-xs-12 text-center">
            <br />
            <strong>Please Note:</strong> If you have a file to submit with your inquiry, please email it to
            <a href="mailto:info@farnam-custom.com">info@farnam-custom.com</a>.
          </p>
        </div>
      </div>

      <div
        class="thank-you-message"
        v-show="state.isThankYouMessageVisible">
        <div class="thank-you-message-title">Thank You!</div>
        <div class="thank-you-message-text">
          You have successfully submitted our contact form. A representative of Tutco Farnam will respond to your request within 2-3 business days.
        </div>
      </div>
    </form>
  </div>
</template>

<script setup lang="ts">
import { onMounted, reactive, ref } from 'vue';
import { ContactFormLogic } from '@/helpers/website/farnam-custom/contactForm.helper';
import DataLayerHelper from '@/helpers/global/dataLayer.helper';
const getAQuoteFormAppWrap = ref(null);

enum FormPlacing {
  onContactPage = 'on-contact-page',
  inBuildYourOwnModal = 'in-build-your-own-modal',
  inGetAQuoteModal = 'in-get-a-quote-modal',
}

const state = reactive({
  formPlacing: FormPlacing.onContactPage as string,
  isThankYouMessageVisible: false as boolean,
  isReCAPTCHAVerified: false as boolean,
});

const loadScriptsAndStyles = () => {
  let jQueryScriptCheckInterval = setInterval(() => {
    if (typeof $ !== 'undefined') {
      let validatorScriptCheckInterval = setInterval(() => {
        if (typeof validatorFunction !== 'undefined') {
          const ContactFormMainLogic = new ContactFormLogic();
          ContactFormMainLogic.init();

          clearInterval(validatorScriptCheckInterval);
        }
      }, 100);

      clearInterval(jQueryScriptCheckInterval);
    }
  }, 100);
};

const getInfoFromDataAttrs = () => {
  if (getAQuoteFormAppWrap.value !== null) {
    const dataAttrFormPlacing = getAQuoteFormAppWrap.value.parentElement.getAttribute('data-form-placing');
    if (dataAttrFormPlacing !== null && dataAttrFormPlacing.length > 0) {
      state.formPlacing = dataAttrFormPlacing;
    }
  }
};

const handleHeatingProjectButtonClick = () => {
  setTimeout(() => {
    var el = document.getElementById('heat-project-button');
    el.scrollIntoView({ behavior: 'smooth' });
  }, 100);
};

const handleBillingButtonClick = () => {
  setTimeout(() => {
    var el = document.getElementById('billing-button');
    el.scrollIntoView({ behavior: 'smooth' });
  }, 100);
};

const handleHumanResourcesButtonClick = () => {
  setTimeout(() => {
    var el = document.getElementById('human-resources-button');
    el.scrollIntoView({ behavior: 'smooth' });
  }, 100);
};

const accordionLogicHandler = () => {
  var accordionsList = document.querySelectorAll('.contact-form-accordion');
  accordionsList.forEach(function (accordion) {
    var accordionHeader = accordion.querySelector('.contact-form-accordion-header');
    var accordionBody = accordion.querySelector('.contact-form-accordion-body');
    var accordionBodyHeight = 0;
    accordionHeader.addEventListener('click', function () {
      if (accordionHeader.classList.contains('active')) {
        accordionHeader.classList.remove('active');
        accordionBody.classList.remove('active');
        accordionBodyHeight = accordionBody.querySelector('.contact-form-accordion-body-content').clientHeight;
        accordionBody.style.height = `${accordionBodyHeight + 2}px`;
        setTimeout(() => {
          accordionBody.style.height = '0px';
        }, 10);
      } else {
        accordionHeader.classList.add('active');
        accordionBody.classList.add('active');
        accordionBodyHeight = accordionBody.querySelector('.contact-form-accordion-body-content').clientHeight;
        accordionBody.style.height = `${accordionBodyHeight + 2}px`;
        setTimeout(() => {
          accordionBody.style.height = 'auto';
        }, 300);
      }
    });
  });
};

const useInquiryButtonsLogic = () => {
  var inquiryButtonsIds = ['#billing-button', '#human-resources-button'];
  inquiryButtonsIds.forEach(function (item) {
    var buttonElement = document.querySelector(item);
    if (buttonElement !== null) {
      buttonElement.addEventListener('click', function () {
        document.querySelector('#fieldset-contact-information').style.display = 'block';
        document.querySelector('.more-info-section').style.display = 'block';
        document.querySelector('#how-did-you-find-us').style.display = 'block';
        document.querySelector('.form-group-checkboxes').style.display = 'block';
        document.querySelector('.form-group-capcha').style.display = 'block';
      });
    }
  });
};

const bottomsButtonsLogic = () => {
  document.querySelector('#Email_Opt_Out').addEventListener('click', function () {
    document.querySelector('#receive-product-updates').checked = !document.querySelector('#Email_Opt_Out').checked;
  });

  document.querySelector('#receive-product-updates').addEventListener('click', function () {
    document.querySelector('#Email_Opt_Out').checked = !document.querySelector('#receive-product-updates').checked;
  });
};

const updateFormPlacingOnButtonsClick = () => {
  const getAQuoteButtons = document.querySelectorAll('.cb-get-a-quote-modal-open-button');
  if (getAQuoteButtons.length > 0) {
    getAQuoteButtons.forEach((button) => {
      button.addEventListener('click', () => {
        state.formPlacing = FormPlacing.inGetAQuoteModal;
      });
    });
  }

  if (document.querySelector('.cb-build-your-own') !== null) {
    setTimeout(() => {
      const waitForSendInquiryButton = setInterval(() => {
        const sendInquiryButton = document.querySelector('#builder-send-inquiry2');
        if (sendInquiryButton) {
          clearInterval(waitForSendInquiryButton);

          sendInquiryButton.addEventListener('click', () => {
            state.formPlacing = FormPlacing.inBuildYourOwnModal;
          });
        }
      }, 100);

      const waitSaveBuilderButton = setInterval(() => {
        const saveBuilderButton = document.querySelector('#builder-send-inquiry');
        if (saveBuilderButton) {
          clearInterval(waitSaveBuilderButton);

          saveBuilderButton.addEventListener('click', () => {
            state.formPlacing = FormPlacing.inBuildYourOwnModal;
          });
        }
      }, 100);
    }, 100);
  }
};

const onFormSubmit = () => {
  document.getElementById('contact_form')?.addEventListener('submit', function (event) {
    event.preventDefault();

    const form = this;

    setTimeout(() => {
      const formGroupsWithErrorList = document.querySelectorAll('.form-group.has-error');

      if (formGroupsWithErrorList.length === 0) {
        const leadSourceInput = document.querySelector('#contact_form #lead-source');
        if (leadSourceInput) {
          leadSourceInput.value += ` - ${document.title} page`;
        }

        document.querySelector('#contact-form-submit-antispam').disabled = true;
        fetch(form.action, {
          method: form.method,
          body: new FormData(form),
        }).then((response) => {
          if (response.ok) {
            var ga_event_name = 'byo_get_a_quote_form_submit';

            if (state.formPlacing === FormPlacing.onContactPage) {
              ga_event_name = 'contact_us_form_submit';
            }
            if (state.formPlacing === FormPlacing.inGetAQuoteModal) {
              ga_event_name = 'get_a_quote_form_submit';
            }
            DataLayerHelper.send(ga_event_name, 'Lead Generation', 'Submit button', 'Contact form', 1);

            state.isThankYouMessageVisible = true;
          }
        });
      } else {
        document.querySelector('#contact_form').scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  });
};

const watchForGetAQuoteModal = () => {
  const getAQuoteModal = document.querySelector('.get-a-quote-form-modal');

  if (getAQuoteModal !== null) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class') {
          if (!mutation.target.classList.contains('in')) {
            setTimeout(() => {
              state.isThankYouMessageVisible = false;
            }, 300);
          }
        }
      });
    });

    observer.observe(getAQuoteModal, { attributes: true, attributeFilter: ['class'] });
  }
};

onMounted(() => {
  getInfoFromDataAttrs();
  loadScriptsAndStyles();
  updateFormPlacingOnButtonsClick();

  setTimeout(() => {
    accordionLogicHandler();
  }, 1000);

  useInquiryButtonsLogic();
  bottomsButtonsLogic();

  onFormSubmit();

  watchForGetAQuoteModal();

  if (state.formPlacing === FormPlacing.onContactPage) {
    const waitForScript = setInterval(() => {
      if (typeof window.isContactFormLoaded === 'function') {
        clearInterval(waitForScript);

        setTimeout(() => {
          document.querySelector('#heat-project-button')?.addEventListener('click', () => {
            document.querySelector('.heating-type-button.forced-air')?.click();
          });

          document.querySelector('#heat-project-button')?.click();
        }, 50);
      }
    }, 100);
  }

  window.EnableHuman = function () {
    document.querySelector('#contact-form-submit-antispam').disabled = false;
  };

  window.DisableHuman = function () {
    document.querySelector('#contact-form-submit-antispam').disabled = true;
  };
});
</script>

<style lang="scss">
@import '@/styles/website/farnam-custom/contact-form.scss';
</style>
